import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formatProductTitle, formatCategoryName } from '../utils/titleFormat';

const ScrollToTop: React.FC = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch (e) {
        (document.body as HTMLElement).scrollTop = 0;
        (document.documentElement as HTMLElement).scrollTop = 0;
      }
    }

    try {
      const path = pathname || '';
      const normalized = path.replace(/\/+$/g, '');

      if (/^\/productos(\/)?$/i.test(normalized)) {
        document.title = 'Comprá online productos en Semillando';
        return;
      }

      if (/^\/productos\//i.test(normalized)) {
        const segments = normalized.split('/');
        const rawSku = decodeURIComponent(segments[segments.length - 1] || '');
        document.title = formatProductTitle(rawSku);
        return;
      }

      if (/^\/categoria\//i.test(normalized)) {
        const segments = normalized.split('/');
        const rawSku = decodeURIComponent(segments[segments.length - 1] || '');
        const formatted = formatCategoryName(rawSku);
        document.title = `Comprá online ${formatted} en Semillando`;
        return;
      }

      document.title = 'Semillando';
    } catch (err) {
      document.title = 'Semillando';
    }
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;














